/*
 * @FilePath     : /es-template/src/api/get-available-travel-list.js
 * @Author       : LiYang
 * @Date         : 2021-10-21 18:36:57
 * @LastEditTime : 2022-01-04 16:00:11
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
import { mpx } from '@didi/es-mpx-creator'
import {
  TRAVELER_MERGE
} from '../../api/urls'

// 获取12306所有乘车人
export const getAllPassenger = data => {
  return mpx.$http.post('/esapp/train/travelers/travelersAllQuery', {
    data
  })
}

//批量添加出行人
export const addTrainPassengers = data => {
  return mpx.$http.post('/esapp/train/travelers/travelersBatchAdd', {
    data
  })
}

//轮训出行人添加状态
export const checkPassengerBatchStatus = data => {
  return mpx.$http.post('/esapp/train/travelers/travelersBatchQuery', {
    data
  })
}

//单个出行人核验
export const trainPassengerValidate = data => {
  return mpx.$http.post('/esapp/train/travelers/travelersValidate', {
    data
  })
}

//获取单个出行人核验状态
export const getPassengerValidateStatus = data => {
  return mpx.$http.post('/esapp/train/travelers/travelersValidateQuery', {
    data
  })
}

//删除12306出行人
export const delPassengers = data => {
  return mpx.$http.post('/esapp/train/travelers/travelersBatchDel', {
    data
  })
}

//查询删除状态
export const getDelPassengersStatus = data => {
  return mpx.$http.post('/esapp/train/travelers/travelersBatchDelQuery', {
    data
  })
}

//上传下载乘车人
export const travelerMergePassenger = data => {
  return mpx.$http.post(TRAVELER_MERGE, {
    data 
  })
}